export default "__VITE_ASSET__c1dc0e6a__"